import dayjs from "dayjs";

/**
 * Extracts a numeric epoch timestamp (in milliseconds) from a file, folder, or nested object.
 */
export const getItemTimestamp = (item) => {
  if (!item) return Date.now();
  const target = item?.file || item?.folder || item;
  const raw =
    target?.created_at ??
    target?.updated_at ??
    target?.date ??
    target?.last_opened_at;

  if (raw === undefined || raw === null || raw === "") return Date.now();

  const num = Number(raw);
  if (!isNaN(num) && num > 0) {
    // If 10 digits (seconds format), convert to milliseconds
    return num < 1e11 ? num * 1000 : num;
  }

  const parsed = dayjs(raw).valueOf();
  return !isNaN(parsed) && parsed > 0 ? parsed : Date.now();
};

/**
 * Checks if an item matches date range filters (after, before) as well as type filters.
 * Returns true if item matches or if no filter is set.
 */
export const matchesDateAndLocalFilter = (item, filter) => {
  if (!filter) return true;
  const { after, before, type, filterType } = filter;

  // 1. Date filter checking (after / before)
  if (after || before) {
    const itemTime = getItemTimestamp(item);
    if (after && itemTime < Number(after)) return false;
    if (before && itemTime > Number(before)) return false;
  }

  // 2. Filter type checking (file vs folder)
  if (filterType && filterType !== "all") {
    const isFolder = Boolean(
      item?.folder ||
        item?.type === "folder" ||
        (item?.id && !item?.file_name && item?.name)
    );
    const isFile = Boolean(
      item?.file || item?.type === "file" || item?.file_name
    );

    if (filterType === "file" && isFolder && !isFile) return false;
    if (filterType === "folder" && isFile && !isFolder) return false;
  }

  // 3. Media/File extension filter type (image, pdf, document, etc.)
  if (type && type !== "all") {
    const isFolder = Boolean(
      item?.folder ||
        item?.type === "folder" ||
        (item?.id && !item?.file_name && item?.name && !item?.mime_type)
    );
    if (isFolder) return false;

    const targetFile = item?.file || item;
    const mime = (
      targetFile?.mime_type ||
      targetFile?.file_type ||
      ""
    ).toLowerCase();
    const fileName = (
      targetFile?.file_name ||
      targetFile?.name ||
      ""
    ).toLowerCase();

    if (
      type === "image" &&
      !mime.startsWith("image/") &&
      !/\.(jpg|jpeg|png|gif|webp|svg|bmp)$/i.test(fileName)
    ) {
      return false;
    }
    if (type === "pdf" && !mime.includes("pdf") && !/\.pdf$/i.test(fileName)) {
      return false;
    }
    if (
      type === "document" &&
      !mime.includes("document") &&
      !mime.includes("word") &&
      !mime.includes("text") &&
      !/\.(doc|docx|txt|pdf|rtf|xls|xlsx|ppt|pptx)$/i.test(fileName)
    ) {
      return false;
    }
  }

  return true;
};
